import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-id-notification-draft',
  templateUrl: './id-notification-draft.component.html',
  styleUrls: ['./id-notification-draft.component.css']
})
export class IdNotificationDraftComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/id-notification-draft/id-notification-draft.component.ts